import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData , downloadPDFData} from '../../services/index';
import { Popconfirm,message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select,DatePicker,Upload, Modal,   } from 'antd';
import { DownloadOutlined,PlusOutlined,PictureOutlined,VideoCameraOutlined,FileOutlined,CloseOutlined,AudioOutlined } from '@ant-design/icons';

import ModalImage from "react-modal-image";
import axios from 'axios';
import $ from 'jquery';



const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}


function disabledDate(current) {
  // Can not select days before today and today
   return current && current > moment().endOf('day');
}

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

const dateFormat = 'YYYY-MM-DD';
const storedFiles=[];
class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			previewVisible: false,
			previewImage: '',
			cau_deposit: '',
			division: '',
			house: '',
			previewTitle: '',
			imageUrl: '',
			fileList: [],
			loading: false,
			value: '',
			values: [0],
			first_name: '',
			student_type: 'Online',
			last_name: '',
			birthday: '',
			blood_group: '',
			gender: '',
			joining_date: '',
			unique_id: '',
			address: '',
			allergies: '',
			modal_title: '',
			notes: '',
			parent_first_name: '',
			parent_last_name: '',
			parent_mobile: '',
			parent_relation: '',
			parent_email: '',
			program_id : '',
			program_list : [],
			student_list : [],
			parent_relation : [],
			delete_parent : [],
			previewImage: '',
			previewTitle: '',
			previewVisible: false,
			file_list: [],
			file_list_pdf: [],
			file_list_audio: [],
			division_list: [],
			image: [],	
			file1:null,
			file2:null,
			file3:null,
			file4:null,
			file5:null,
			old_file1: '',
			old_file2: '',
			old_file3: '',
			old_file4: '',
			old_file5: '',
			transfer_certificate_details: '',
			health_certificate_details: '',
			bonafied_certificate_details: '',
			nirgam_document_details:'',
			id_card_details: '',
			day_care: 0,
			actual_fee: 0,
			transport: 0,
			total_fee: 0,			
			admission_fee:0,
			admission_form:0,
			confirmation_fee:0,
			tuition_fee_1:0,
			tuition_fee_1_date:'',
			tuition_fee_2:0,
			tuition_fee_2_date:'',
			tuition_fee_3:0,
			tuition_fee_3_date:'',
			starter_kit:0,
			uniform:0,
			activity_fee:0,
			total_fee:0,
			deposit:0,
			transport_term_1:0,
			transport_term_1_date:'',
			transport_term_2:0,
			transport_term_2_date:'',
			january:0,
			january_due_date:'',
			february:0,
			february_due_date:'',
			march:0,
			march_due_date:'',
			april:0,
			april_due_date:'',
			may:0,
			may_due_date:'',
			june:0,
			june_due_date:'',
			july:0,
			july_due_date:'',
			august:0,
			august_due_date:'',
			september:0,
			september_due_date:'',
			october:0,
			october_due_date:'',
			november:0,
			november_due_date:'',
			december:0,
			december_due_date:'',
			is_promote:0,
			file1:null,
			file2:null,
			file3:null,
			file4:null,
			file5:null,
			file6:null,
			file7:null,
			file8:null,
			file9:null,
			file10:null,
			file11:null,
			file12:null,
			file13:null,
			file15:null,
			old_file1: '',
			old_file2: '',
			old_file3: '',
			old_file4: '',
			old_file5: '',
			old_file6: '',
			old_file7: '',
			old_file8: '',
			old_file9: '',
			old_file10: '',
			old_file11: '',
			old_file12: '',
			old_file13: '',
			old_file14: '',
			birth_cert_details: '',
			transfer_certificate_details: '',
			last_exam_marksheet_details: '',
			mother_photo_detalis: '',
			father_photo_detalis: '',
			cast_certificate_details: '',
			health_certificate_details: '',
			vaccination_card_details: '',
			father_aadhar_details: '',
			mother_aadhar_details: '',
			student_aadhar_details: '',
			address_doc_details: '',
			death_certificate_details: '',
			admission_form_details: '',
			permission: '',
			type: '',
			user_type: '',
			place_search: [],
			transport_details: [],
			academic_year_: [],
			state_list: [],
			state: '',
			city_list: [],
			city: '',
			address: '',
			emergency: 'Yes',
			language: '',
			pincode: '',
			language: '',
			payment_type: '',
			payment_reference: '',
			fees_modal: false,
			loading: false,
			modal_table: '',
			modal_type: '',
			modal_title: '',
		}
		this.handleSizeChange = this.handleSizeChange.bind(this);
		this.change_payment_type = this.change_payment_type.bind(this);
		this.getTotal = this.getTotal.bind(this);
		
	}

	componentWillMount() {
		if(document.querySelector(".loader-wrapper")){
			document.querySelector(".loader-wrapper").style = "display: none";
		}
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		var permission = storedArray['data'][0]['permission'];
		var type = storedArray['data'][0]['type'];
		//alert(type);
		this.setState({ user_id : storedArray['data'][0]['user_id'],id : this.props.match.params.id,school_id : storedArray['data'][0]['school_id'],user_type : type,permission : permission });
		this.checkData();
		}
	}
	 
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 this.setState({ 
			 school_id : storedArray['data'][0]['school_id'], 
			 user_id : storedArray['data'][0]['user_id'], 
			 id : this.props.match.params.id, 
			 });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var type = storedArray['data'][0]['type'];
			var id = this.props.match.params.id;
			var app = {user_id : user_id,id:id,school_id:school_id,type:type}
			getData('erp/student_fees_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							student_list: result['data'],
							is_promote: result['data'][0]['is_promote'],
							first_name: result['data'][0]['first_name'],
							last_name: result['data'][0]['last_name'],
							birthday: result['data'][0]['birthday'],
							program_id: result['data'][0]['program_id'],
							transport: result['data'][0]['is_transport'],	
							day_care: result['data'][0]['is_day_care'],	
							is_fees: result['data'][0]['is_fees'],	
							program_name: result['data'][0]['program_name'],
							initial_fee: result['data'][0]['initial_fee'],
							initial_fee_paid: result['data'][0]['initial_fee_paid'],

							actual_fee:  result['data'][0]['actual_fee'],
							actual_fee_paid :  result['data'][0]['actual_fee_paid'],
							admission_fee:  result['data'][0]['admission_fee'],
							admission_fee_paid:  result['data'][0]['admission_fee_paid'],
							admission_form:  result['data'][0]['admission_form'],
							admission_form_paid:  result['data'][0]['admission_form_paid'],
							confirmation_fee:  result['data'][0]['confirmation_fee'],
							confirmation_fee_paid:  result['data'][0]['confirmation_fee_paid'],
							tuition_fee_1:  result['data'][0]['tuition_fee_1'],
							tuition_fee_1_paid:  result['data'][0]['tuition_fee_1_paid'],
							tuition_fee_1_date:  result['data'][0]['tuition_fee_1_date'],
							tuition_fee_2:  result['data'][0]['tuition_fee_2'],
							tuition_fee_2_paid:  result['data'][0]['tuition_fee_2_paid'],
							tuition_fee_2_date:  result['data'][0]['tuition_fee_2_date'],
							tuition_fee_3:  result['data'][0]['tuition_fee_3'],
							tuition_fee_3_paid:  result['data'][0]['tuition_fee_3_paid'],
							tuition_fee_3_date:  result['data'][0]['tuition_fee_3_date'],
							starter_kit:  result['data'][0]['starter_kit'],
							starter_kit_paid:  result['data'][0]['starter_kit_paid'],
							uniform:  result['data'][0]['uniform'],
							uniform_paid:  result['data'][0]['uniform_paid'],
							activity_fee:  result['data'][0]['activity_fee'],
							activity_fee_paid:  result['data'][0]['activity_fee_paid'],
							total_fee:  result['data'][0]['total_fee'],
							transport_term_1:  result['data'][0]['transport_term_1'],
							transport_term_1_paid:  result['data'][0]['transport_term_1_paid'],
							transport_term_1_date:  result['data'][0]['transport_term_1_date'],
							transport_term_2:  result['data'][0]['transport_term_2'],
							transport_term_2_paid:  result['data'][0]['transport_term_2_paid'],
							transport_term_2_date:  result['data'][0]['transport_term_2_date'],
							cau_deposit:  result['data'][0]['cau_deposit'],
							cau_deposit_paid:  result['data'][0]['cau_deposit_paid'],
							deposit:  result['data'][0]['deposit'],
							deposit_paid:  result['data'][0]['deposit_paid'],
							january:  result['data'][0]['january'],
							january_paid:  result['data'][0]['january_paid'],
							january_due_date:  result['data'][0]['january_due_date'],
							february:  result['data'][0]['february'],
							february_paid:  result['data'][0]['february_paid'],
							february_due_date:  result['data'][0]['february_due_date'],
							march:  result['data'][0]['march'],
							march_paid:  result['data'][0]['march_paid'],
							march_due_date:  result['data'][0]['march_due_date'],
							april:  result['data'][0]['april'],
							april_paid:  result['data'][0]['april_paid'],
							april_due_date:  result['data'][0]['april_due_date'],
							may:  result['data'][0]['may'],
							may_paid:  result['data'][0]['may_paid'],
							may_due_date:  result['data'][0]['may_due_date'],
							june:  result['data'][0]['june'],
							june_paid:  result['data'][0]['june_paid'],
							june_due_date:  result['data'][0]['june_due_date'],
							july:  result['data'][0]['july'],
							july_paid:  result['data'][0]['july_paid'],
							july_due_date:  result['data'][0]['july_due_date'],
							august:  result['data'][0]['august'],
							august_paid:  result['data'][0]['august_paid'],
							august_due_date:  result['data'][0]['august_due_date'],
							september:  result['data'][0]['september'],
							september_paid:  result['data'][0]['september_paid'],
							september_due_date:  result['data'][0]['september_due_date'],
							october:  result['data'][0]['october'],
							october_paid:  result['data'][0]['october_paid'],
							october_due_date:  result['data'][0]['october_due_date'],
							november:  result['data'][0]['november'],
							november_paid:  result['data'][0]['november_paid'],
							november_due_date:  result['data'][0]['november_due_date'],
							december:  result['data'][0]['december'],
							december_paid:  result['data'][0]['december_paid'],
							december_due_date:  result['data'][0]['december_due_date'],
							
						});
						
								
						
					}else{
						this.setState({
							student_list: [],
						});
					}
				}
			});				
	}
	}
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	};
	
	change_payment_type = e => {
		this.setState({ payment_type: e });
	};
	  
	  
	getTotal = e => {
		if(this.state.admission_fee !=''){ var admission_fee = this.state.admission_fee}else{ var admission_fee = 0}
		if(this.state.admission_form !=''){ var admission_form = this.state.admission_form}else{ var admission_form = 0}
		if(this.state.confirmation_fee !=''){ var confirmation_fee = this.state.confirmation_fee}else{ var confirmation_fee = 0}
		if(this.state.tuition_fee_1 !=''){ var tuition_fee_1 = this.state.tuition_fee_1}else{ var tuition_fee_1 = 0}
		if(this.state.tuition_fee_2 !=''){ var tuition_fee_2 = this.state.tuition_fee_2}else{ var tuition_fee_2 = 0}
		if(this.state.tuition_fee_3 !=''){ var tuition_fee_3 = this.state.tuition_fee_3}else{ var tuition_fee_3 = 0}
		if(this.state.starter_kit !=''){ var starter_kit = this.state.starter_kit}else{ var starter_kit = 0}
		if(this.state.uniform !=''){ var uniform = this.state.uniform}else{ var uniform = 0}
		if(this.state.activity_fee !=''){ var activity_fee = this.state.activity_fee}else{ var activity_fee = 0}
		
		var total = parseInt(admission_fee)+parseInt(admission_form)+parseInt(confirmation_fee)+parseInt(tuition_fee_1)+parseInt(tuition_fee_2)+parseInt(tuition_fee_3)+parseInt(starter_kit)+parseInt(uniform)+parseInt(activity_fee);
		this.setState({ total_fee: total });
	};
	
	DownloadReceipt = (type,fees_id) => {
		if(localStorage.getItem('schoolData')){
		var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		var user_id = storedArray['data'][0]['user_id'];
		var school_id = storedArray['data'][0]['school_id'];	
		var app = {user_id:this.props.match.params.id,school_id:school_id,type:type,fees_id:fees_id}
		  downloadPDFData('order/download_reciept',app,'fees_receipt').then((result) => {
			if(result.status==400){
				message.config({ top: 150});
				message.error('Something Went Wrong !!',2);
			}
		  });
		}
	};
	
	showModal = (type,title,table,fees_id,fees_amount,total_tuition_fees_id) => {
		var type_id = [];
		if(total_tuition_fees_id && total_tuition_fees_id.length > 0){
			type_id = total_tuition_fees_id
		}
		this.setState({ fees_modal: true,modal_title:title,modal_type:type,modal_table:table,fees_id:fees_id,type_id:type_id,fees_amount:fees_amount });
	};
	
	handleOk  = () => {
		
		if(localStorage.getItem('schoolData')){
		var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		var user_id = storedArray['data'][0]['user_id'];
		var school_id = storedArray['data'][0]['school_id'];	
		this.setState({ loading: true });
		var app = {user_id:this.props.match.params.id,school_id:school_id,type:this.state.modal_type,table:this.state.modal_table,payment_type:this.state.payment_type,reference_no:this.state.payment_reference,fees_id:this.state.fees_id,type_id:this.state.type_id,fees_amount:this.state.fees_amount}
		  getData('order/admin_pay',app).then((result) => {
		  if(result.status==400){
				alert(result.message);
			  }
			  if(result.status==200){
				message.config({ top: 150});
				message.success('Fees Pay Successfully !!',2);
					this.setState({ loading: false });
					this.setState({ fees_modal: false,modal_title:'',modal_type:'',modal_table:'',fees_id:'',payment_type:'',reference_no:'',type_id:'' });
					setTimeout(() => {
						this.checkData();
					}, 500);
			  }
		  });
		  }else{
			message.error('Please Login',2);	
		  }
	};
	
	handleCancel   = () => {
		this.setState({ fees_modal: false,modal_title:'',modal_type:'',fees_id:'' });
	};
  
  

     handleChange = ({ fileList }) => this.setState({ fileList });

	render()

	{
	
	const { size } = this.state;
	const { previewVisible, previewImage, fileList, previewTitle } = this.state;
    
					
		return (
		<>
			<Modal className="pay-fees-modal" title={this.state.modal_title} visible={this.state.fees_modal} onOk={this.handleOk.bind(this)} onCancel={this.handleCancel.bind(this)}>
				<div class="row">
				<div class="col-md-12">
				<div class="form-group">
					<label>Payment Type*</label>
					<Select onChange={this.change_payment_type} value={this.state.payment_type}>
						<Select.Option value="">Select</Select.Option>
						<Select.Option value="Cash">Cash</Select.Option>
						<Select.Option value="Cheque">Cheque</Select.Option>
						<Select.Option value="Online">Online</Select.Option>
						
					</Select>
				</div>
				</div>
				<div class="col-md-12">
				<div class="form-group">
					<label>Payment Reference No.*</label>
					<input type="text" class="form-control" name="payment_reference" value={this.state.reference_no} onChange={this.handleSizeChange} />
				</div>
				</div>
				<div class="col-md-12">
				<div class="form-group center">
					<Button className="btn btn-primary mr-2" onClick={this.handleOk.bind(this)} loading={this.state.loading}>Submit</Button>
				</div>
				</div>
				</div>
			</Modal>
			<div class="mobile_view">
			<div class="row bred">
				<div class="col-md-12">
					<div class="card">
						<div class="card-body">
							<h4 class="page-title"> 
								<i class="mdi mdi-apple-keyboard-command title_icon"></i>View Fees - {this.state.first_name} {this.state.last_name}
								<div class="breadcrumb-wrapper">
									<ol class="breadcrumb">
										<li class="breadcrumb-item">
											<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
											<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
											</a>
										</li>
										<li class="breadcrumb-item"> <a href={`${process.env.PUBLIC_URL}/children-profiles`} class="router-link-active" target="_self">Child Profile </a></li>
									</ol>
								</div>
							</h4>
						</div>
					</div>
				</div>
			</div>
			
			<div id="main" class="bg-off">
         <div class="row">
	
			  {this.state.student_list.map((list) => (
			<div class="col-md-12 ex-padd">
            
            <div class="view-Profile child-profile view-Profile-mobile">
			   <div class="col-md-12 mb-20 card-content iq-card">
                  <section class="invoice-list-wrapper section food ">
					
					
					<>
					
					<div class="children bg-blue  bg-color-6 communication mb-20 iq-card2 form-group fees-package-mod">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header={`${this.state.program_name} Fees Package `} key="1">
						  <div class="form-group pay-fees-div">
						     <div class="row">
							 
						     <div class="col-md-12 mb-20">
								{list.note != '' && (<>
									<p class="fees-notes">Note : {list.note}</p>
								</>)}
								<table>
									<tbody>
										
										<tr>
											<td>Initial Fee</td>
											<td>Rs. {list.initial_fee} /- </td>
											<td> 
											{(list.initial_fee_paid == 0 || list.initial_fee_paid == 2) ? (<>
												{list.initial_fee_paid == 2 ? (<>
												<span class="fees-process">In Process</span>
												</>):(<>
												<Button className="btn btn-primary mr-2" >Unpaid</Button>
												</>)}
											</>):(<>
												<span class="fees-paid">Paid</span>
												<span class="fees-download" onClick={this.DownloadReceipt.bind(this,'initial_fee',list.fees_id)}><DownloadOutlined /> Download Receipt</span>
											</>)}
											</td>
										</tr>
										
										<tr>
											<td>Admission Fee</td>
											<td>Rs. {list.admission_fee} /- </td>
											<td> 
											{(list.admission_fee_paid == 0 || list.admission_fee_paid == 2)? (<>
												{list.admission_fee_paid == 2 ? (<>
												<span class="fees-process">In Process</span>
												</>):(<>
												<Button className="btn btn-primary mr-2" >Unpaid</Button>
												</>)}
												
											</>):(<>
												<span class="fees-paid">Paid</span>
												<span class="fees-download" onClick={this.DownloadReceipt.bind(this,'admission_fee',list.fees_id)}><DownloadOutlined /> Download Receipt</span>
											</>)}
											</td>
										</tr>
										<tr>
											<td>Admission Form</td>
											<td>Rs. {list.admission_form} /- </td>
											<td>
											{(list.admission_form_paid == 0 || list.admission_form_paid == 2) ? (<>
												{list.admission_form_paid == 2 ? (<>
												<span class="fees-process">In Process</span>
												</>):(<>
												<Button className="btn btn-primary mr-2" >Unpaid</Button>
												</>)}
											</>):(<>
											
												<span class="fees-paid">Paid</span>
												<span class="fees-download" onClick={this.DownloadReceipt.bind(this,'admission_form',list.fees_id,list.admission_form)}><DownloadOutlined /> Download Receipt</span>
											</>)}
											</td>
										</tr>
										<tr>
											<td>Caution deposit </td>
											<td>Rs. {list.cau_deposit} /- </td>
											<td>
											{(list.cau_deposit_paid == 0 || list.cau_deposit_paid == 2) ? (<>
												{list.cau_deposit_paid == 2 ? (<>
												<span class="fees-process">In Process</span>
												</>):(<>
												<Button className="btn btn-primary mr-2" >Unpaid</Button>
												</>)}
											</>):(<>
											
												<span class="fees-paid">Paid</span>
												{this.state.is_promote == 1 ? (<>
												<span class="fees-download" > Carry Forward</span>
												</>):(<>
												<span class="fees-download" onClick={this.DownloadReceipt.bind(this,'deposit',list.fees_id,list.cau_deposit)}><DownloadOutlined /> Download Receipt</span>
												</>)}
											</>)}
											</td>
										</tr>
										<tr>
											<td>Starter Kit/Books</td>
											<td>Rs. {list.starter_kit} /- </td>
											<td>
											{(list.starter_kit_paid == 0 || list.starter_kit_paid == 2) ? (<>
												{list.starter_kit_paid == 2 ? (<>
												<span class="fees-process">In Process</span>
												</>):(<>
												<Button className="btn btn-primary mr-2" >Unpaid</Button>
												</>)}
											</>):(<>
											
												<span class="fees-paid">Paid</span>
												<span class="fees-download" onClick={this.DownloadReceipt.bind(this,'starter_kit',list.fees_id,list.starter_kit)}><DownloadOutlined /> Download Receipt</span>
											</>)}
											</td>
										</tr>
										<tr>
											<td>Uniform</td>
											<td>Rs. {list.uniform} /- </td>
											<td>
											{(list.uniform_paid == 0 || list.uniform_paid == 2) ? (<>
												{list.uniform_paid == 2 ? (<>
												<span class="fees-process">In Process</span>
												</>):(<>
												<Button className="btn btn-primary mr-2" >Unpaid</Button>
												</>)}
											</>):(<>
											
												<span class="fees-paid">Paid</span>
												<span class="fees-download" onClick={this.DownloadReceipt.bind(this,'uniform',list.fees_id,list.uniform)}><DownloadOutlined /> Download Receipt</span>
											</>)}
											</td>
										</tr>
										<tr>
											<td>Activity Fee</td>
											<td>Rs. {list.activity_fee} /- </td>
											<td>
											{(list.activity_fee_paid == 0 || list.activity_fee_paid == 2) ? (<>
												{list.activity_fee_paid == 2 ? (<>
												<span class="fees-process">In Process</span>
												</>):(<>
												<Button className="btn btn-primary mr-2" >Unpaid</Button>
												</>)}
											</>):(<>
											
												<span class="fees-paid">Paid</span>
												<span class="fees-download" onClick={this.DownloadReceipt.bind(this,'activity_fee',list.fees_id,list.activity_fee)}><DownloadOutlined /> Download Receipt</span>
											</>)}
											</td>
										</tr>
										<tr>
											<td>Confirmation Tuition Fee 1</td>
											<td>Rs. {list.confirmation_fee} /- </td>
											<td>
											{(list.confirmation_fee_paid == 0 || list.confirmation_fee_paid == 2) ? (<>
												{list.confirmation_fee_paid == 2 ? (<>
												<span class="fees-process">In Process</span>
												</>):(<>
												<Button className="btn btn-primary mr-2" >Unpaid</Button>
												</>)}
											</>):(<>
											
												<span class="fees-paid">Paid</span>
												<span class="fees-download" onClick={this.DownloadReceipt.bind(this,'confirmation_fee',list.fees_id,list.confirmation_fee)}><DownloadOutlined /> Download Receipt</span>
											</>)}
											</td>
										</tr>
										<tr>
											<td>Tuition Fee 2 </td>
											<td>Rs. {list.tuition_fee_1} /- </td>
											<td>
											{(list.tuition_fee_1_paid == 0 || list.tuition_fee_1_paid == 2) ? (<>
												{list.tuition_fee_1_paid == 2 ? (<>
												<span class="fees-process">In Process</span>
												</>):(<>
												<Button className="btn btn-primary mr-2" >Unpaid</Button>
												</>)}
											</>):(<>
											
												<span class="fees-paid">Paid</span>
												<span class="fees-download" onClick={this.DownloadReceipt.bind(this,'tuition_fee_1',list.fees_id,list.tuition_fee_1)}><DownloadOutlined /> Download Receipt</span>
											</>)}
											</td>
										</tr>
										<tr>
											<td>Tuition Fee 3 </td>
											<td>Rs. {list.tuition_fee_2} /- </td>
											<td>
											{(list.tuition_fee_2_paid == 0 || list.tuition_fee_2_paid == 2) ? (<>
												{list.tuition_fee_2_paid == 2 ? (<>
												<span class="fees-process">In Process</span>
												</>):(<>
												<Button className="btn btn-primary mr-2" >Unpaid</Button>
												</>)}
											</>):(<>
											
												<span class="fees-paid">Paid</span>
												<span class="fees-download" onClick={this.DownloadReceipt.bind(this,'tuition_fee_2',list.fees_id,list.tuition_fee_2)}><DownloadOutlined /> Download Receipt</span>
											</>)}
											</td>
										</tr>
										<tr>
											<td>Tuition Fee 4</td>
											<td>Rs. {list.tuition_fee_3} /- </td>
											<td>
											{(list.tuition_fee_3_paid == 0 || list.tuition_fee_3_paid == 2) ? (<>
												{list.tuition_fee_3_paid == 2 ? (<>
												<span class="fees-process">In Process</span>
												</>):(<>
												<Button className="btn btn-primary mr-2" >Unpaid</Button>
												</>)}
											</>):(<>
											
												<span class="fees-paid">Paid</span>
												<span class="fees-download" onClick={this.DownloadReceipt.bind(this,'tuition_fee_3',list.fees_id,list.tuition_fee_3)}><DownloadOutlined /> Download Receipt</span>
											</>)}
											</td>
										</tr>
										
										{list.invoice_url != '' ? (<>
										<tr>
											<td>Consolidated Tuition Fee</td>
											<td> </td>
											<td>
												
												<span class="fees-download" onClick={this.DownloadReceipt.bind(this,'invoice_url',list.fees_id,'')}><DownloadOutlined /> Download Receipt</span>
											</td>
										</tr>
										</>):(<></>)}
										
										<tr>
											<td class="total-amount">Total </td>
											<td class="total-amount"><span name="total_fee">Rs. {list.total_fee} /-</span></td>
											<td></td>
										</tr>
									</tbody>
								</table>
							  </div>
							 
							  </div>
						   </div>
						</Panel>
					  </Collapse>
					</div>
					
					{list.is_transport == 1 && (<>
					<div class="children bg-blue  bg-color-6 communication mb-20 iq-card2 form-group fees-package-mod">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header={` Transport `} key="1">
						  <div class="form-group pay-fees-div">
						     <div class="row">
								<div class="col-md-12 no-padd">	
									{(list.transport_note != '') && (<>
										<p class="fees-notes">Note : {list.transport_note}</p>
									</>)}
									<table>
										<tbody>
											<tr>
												{list.transport_way == 1 ? (<>
												<th colspan="3" class="center"><b>One Way</b></th>
												</>):(<>
												<th colspan="3" class="center"><b>Two Way</b></th>
												</>)}
											</tr>
											<tr>
												<td>Transport  Term 1</td>
												<td>Rs. {list.transport_term_1} /- </td>
												<td>
												{(list.transport_term_1_paid == 0 || list.transport_term_1_paid == 2) ? (<>
												{list.transport_term_1_paid == 2 ? (<>
												<span class="fees-process">In Process</span>
												</>):(<>
												<Button className="btn btn-primary mr-2" >Unpaid</Button>
												</>)}
											</>):(<>
												
													<span class="fees-paid">Paid</span>
													<span class="fees-download" onClick={this.DownloadReceipt.bind(this,'transport_term_1',list.fees_id,list.transport_term_1)}><DownloadOutlined /> Download Receipt</span>
												</>)}
												</td>
											</tr>
											<tr>
												<td>Transport  Term 2</td>
												<td>Rs. {list.transport_term_2} /- </td>
												<td>
												{(list.transport_term_2_paid == 0 || list.transport_term_2_paid == 2) ? (<>
												{list.transport_term_2_paid == 2 ? (<>
												<span class="fees-process">In Process</span>
												</>):(<>
												<Button className="btn btn-primary mr-2" >Unpaid</Button>
												</>)}
											</>):(<>
												
													<span class="fees-paid">Paid</span>
													<span class="fees-download" onClick={this.DownloadReceipt.bind(this,'transport_term_2',list.fees_id,list.transport_term_2)}><DownloadOutlined /> Download Receipt</span>
												</>)}
												</td>
											</tr>
										</tbody>
									</table>
									</div>	
							  </div>
						   </div>
						</Panel>
					  </Collapse>
					</div>
					</>)}
					
					
					
					{list.is_summer == 1 && (<>
					<div class="children bg-blue  bg-color-6 communication mb-20 iq-card2 form-group fees-package-mod">
                     <Collapse defaultActiveKey={['1']} onChange={callback}>
						<Panel header={`Summer Camp `} key="1">
						  <div class="form-group pay-fees-div">
						     <div class="row">
								<div class="col-md-12">	
									<table>
										<tbody>
											<tr>
												<td>Summer Camp</td>
												<td>Rs. {list.summer_camp} /- </td>
												<td>
												{(list.summer_camp_paid == 0 || list.summer_camp_paid == 2) ? (<>
												{list.summer_camp_paid == 2 ? (<>
												<span class="fees-process">In Process</span>
												</>):(<>
												<Button className="btn btn-primary mr-2" >Unpaid</Button>
												</>)}
											</>):(<>
												
													<span class="fees-paid">Paid</span>
													<span class="fees-download" onClick={this.DownloadReceipt.bind(this,'summer_camp',list.summer_fees_id,list.summer_camp)}><DownloadOutlined /> Download Receipt</span>
												</>)}
												</td>
											</tr>
										</tbody>
									</table>	
									</div>	
							  </div>
						   </div>
						</Panel>
					  </Collapse>
					</div>
					</>)}
					
					
					
					
					
								

					</>	
					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
			))}
         </div>
      </div>
     
			</div>
		</>	
		) 
	} 
}
export default Index;
